import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {ATIVAR_USUARIO_EMPRESA} from '../types';
import {URL} from '../../util/ambienteActions';

export default function ativarUsuario(idUsuario, idEmpresa) {
    const url = `${URL}/usuarios/${idUsuario}/empresa/${idEmpresa}/ativar`;
    return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ATIVAR_USUARIO_EMPRESA,
            payload: response
        })
    );
}
